var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowHoverRightWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8866 15.5267L15.06 12.7C14.9348 12.5738 14.7644 12.5028 14.5866 12.5028C14.4089 12.5028 14.2385 12.5738 14.1133 12.7C13.8548 12.96 13.8548 13.38 14.1133 13.64L16.4733 16L14.1133 18.36C13.8548 18.62 13.8548 19.04 14.1133 19.3C14.2391 19.4248 14.4094 19.4944 14.5866 19.4933C14.7638 19.4944 14.9341 19.4248 15.06 19.3L17.8866 16.4733C18.0128 16.3482 18.0838 16.1778 18.0838 16C18.0838 15.8222 18.0128 15.6519 17.8866 15.5267Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHoverRightWhite);
export default __webpack_public_path__ + "static/media/arrow-hover-right-white.f99e55e498e84e9456d2b67c5a9c86d0.svg";
export { ForwardRef as ReactComponent };